'use client';

import { type FC, useEffect, useState } from 'react';
import cookie from 'react-cookies';
import { Modal, ModalContent } from '@paypoteam/ui-components';

import { Title } from '@/components/atoms/Typography/Title';
import { IconPointerList } from '@/components/molecules/IconPointerList';
import RegistrationForm from '@/components/organisms/RegistrationForm';

import { REGISTRATION_MODAL_CONFIG } from '@/static/content/pl/common';

export interface RegistrationModalProps {
    timeout: number;
}

const RegistrationModal: FC<RegistrationModalProps> = ({ timeout }) => {
    const [isRegistrationModalVisible, setIsRegistrationModalVisible] =
        useState(false);

    const [isCookieConsent, setIsCookieConsent] = useState(
        cookie.load('CookieConsent'),
    );

    const isRegistrationModalRejected = cookie.load(
        'pp_registration_modal_rejected',
    );
    const hasUserLoggedIn = cookie.load('pp_user_logged_in');

    const isRegistrationModalAllowed =
        !isRegistrationModalRejected && !hasUserLoggedIn;

    useEffect(() => {
        if (!isCookieConsent) {
            const cookieIntervalId = setInterval(() => {
                setIsCookieConsent(cookie.load('CookieConsent'));
            }, 30000);

            return () => clearInterval(cookieIntervalId);
        }
    }, [isCookieConsent]);

    useEffect(() => {
        if (!isRegistrationModalVisible && isRegistrationModalAllowed) {
            const modalTimoutId = setTimeout(() => {
                setIsRegistrationModalVisible(true);
            }, timeout);

            return () => clearTimeout(modalTimoutId);
        }
    }, [isRegistrationModalVisible, isRegistrationModalAllowed, timeout]);

    const handleClose = () => {
        const currentDate = new Date();

        cookie.save('pp_registration_modal_rejected', 'true', {
            secure: true,
            expires: new Date(currentDate.setMonth(currentDate.getMonth() + 1)),
        });
        setIsRegistrationModalVisible(false);
    };

    const { title, listData } = REGISTRATION_MODAL_CONFIG;

    return (
        <Modal
            open={isRegistrationModalVisible}
            onOpenChange={handleClose}
        >
            <ModalContent
                title={title}
                className="!max-h-fit"
            >
                <RegistrationForm
                    isSubmitButtonSticky={true}
                    formName="PopupRejestracja"
                >
                    <Title
                        size="m"
                        className="py-4"
                    >
                        Co zyskujesz?
                    </Title>

                    {listData && (
                        <IconPointerList
                            className="pb-4"
                            listData={listData || []}
                        />
                    )}
                </RegistrationForm>
            </ModalContent>
        </Modal>
    );
};

export default RegistrationModal;
